import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

import Locations from '../vuejs/components/Locations'

// Import Fontawsome
import '../vuejs/utilities/fontawesome.js'

import VueFuse from 'vue-fuse'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueFuse)

Vue.component('Locations', Locations)

new Vue({
  el: '#app'
})
